import { ReactElement } from 'react'

import { InputNumber, type InputNumberProps } from 'antd'
import classNames from 'classnames'
import { getIn } from 'formik'

import { FormikWithCustomHandlersProps } from '../propTypes'
import withCustomHandlers from '../withCustomHandlers'

type Props<V> = FormikWithCustomHandlersProps<V> & InputNumberProps

function FormikInputNumber<V extends number>({
    field: { value, name },
    form,
    handleChange,
    handleBlur,
    handleClick,
    ...props
}: Props<V>): ReactElement {
    return (
        <InputNumber
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            className={classNames({
                'fg-control-error':
                    getIn(form.errors, name) && getIn(form.touched, name),
            })}
            {...props}
        />
    )
}

export default withCustomHandlers(FormikInputNumber)
